import React, { useContext, useEffect, useState } from 'react';
import { A, Img } from '../../hybrid/wrappers';
import Single from '../../layouts/single/Single/Single';
import { logOutFunction } from '../../common/utils/utils';
import { getData } from '../../common/utils/router';
import UserContext from '../../common/utils/getContext';
import T, { t } from '../../common/components/T';
import css from './error.module.scss';
import classNames from 'classnames';

const ErrorPage = ({
    title,
    imgPath,
    subtitle,
    errorCode,
    supportLink,
    errorTimeText,
    errorTime,
    siteError,
    text,
    auth,
    buttonText,
    logout,
    translates,
    hiddenBtn,
    failTests = true
}) => {
    const { lang, setState } = useContext(UserContext);

    const [, setMail] = useState('+7 707 321 21 21');
    const [phoneSupport] = useState('+7 707 321 21 21');

    const isIOS = typeof window !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = typeof window !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    useEffect(() => {
        (async () => {
            if (supportLink) {
                const data = await getData('/api/v1/feedback/queries/support', null, lang);
                if (data?.email) {
                    setMail(data.email);
                }
            }
        })();
    }, [lang, supportLink]);

    return (
        <Single errorPage={failTests} translates={translates} smallFooter={false} title={title}>
            <div className={css.errorPageWrap}>
                <div className={css.container}>
                    <div className={classNames(css.row, css.rowNative, css.flexColumn, css.textCenter, css.alignItemsCenter)}>
                        <div className={css.mask_wrapper}>
                            {isIOS && isSafari ? (
                                <div className={css.mask_ios}>
                                    <Img src={imgPath} alt='Error' className={css.maskImg} />
                                </div>
                            ) : (
                                <div
                                    className={css.mask}
                                    style={{ maskImage: `url(${imgPath})`, WebkitMaskImage: `url(${imgPath})` }}
                                >
                                    <video autoPlay loop muted className={css.background_video}>
                                        <source src='/src/video/office/bg_video.mp4' type='video/mp4' />
                                    </video>
                                </div>
                            )}
                        </div>

                        {siteError ? (
                            text && ''
                        ) : !!errorCode ? (
                            <div className={classNames(css.textGrayLight, css.errorBox)}>
                                <div
                                    className={classNames(css.errorBox_code, {
                                        [css.errorBox_code__border]: errorTimeText
                                    })}
                                >
                                    <span>
                                        <T textName='errorCode' defaultStr='Код страницы' page='/error' />
                                        <span className={css.errorBox_separator}>{':'}</span>
                                    </span>
                                    <span>{errorCode}</span>
                                </div>

                                {errorTimeText ? (
                                    <div className={css.errorBox_date}>
                                        <span>
                                            <T textName='errorTimeText' defaultStr='Время возникновения' page='/error' />
                                            <span className={css.errorBox_separator}>{':'}</span>
                                        </span>
                                        <span>{errorTime || ''}</span>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        ) : (
                            ''
                        )}

                        <div className={css.errorTitle_wrapper}>
                            <h2 className={classNames(css.errorTitle)}>{title}</h2>
                        </div>
                        <div className={classNames(css.blockSm, css.centered, css.offsetBottom10)}>
                            <p className={classNames(css.textSm, css.textDefaultColor)}>
                                {subtitle}
                                {text && (
                                    <div className={classNames(css.blockSm, css.centered, css.offsetBottom10)}>
                                        <p className={classNames(css.textSm, css.textDefaultColor)}>
                                            {text}
                                            <span>
                                                <A href={`tel:${phoneSupport}`} className={classNames(css.linkDefault)}>
                                                    {phoneSupport}
                                                </A>
                                            </span>
                                        </p>
                                    </div>
                                )}
                                {supportLink && !text && (
                                    <A href={`tel:${phoneSupport}`} className={classNames(css.linkDefault)}>
                                        {phoneSupport}
                                    </A>
                                )}
                            </p>
                        </div>

                        {!hiddenBtn && (
                            <div className={css.buttonWrap}>
                                {logout ? (
                                    <div
                                        className={classNames(css.button, css.buttonYellow, css.buttonMd)}
                                        onClick={async () => await logOutFunction()}
                                    >
                                        <p>{buttonText}</p>
                                    </div>
                                ) : auth ? (
                                    <div
                                        className={classNames(css.button, css.buttonYellow, css.buttonSm)}
                                        onClick={() => setState('showRegWindow', { type: 'login' })}
                                    >
                                        <p>
                                            <T textName='auth_button' defaultStr='Авторизация' page='/error' />
                                        </p>
                                    </div>
                                ) : (
                                    <A href={`/`} className={classNames(css.button, css.buttonYellow, css.buttonMd)}>
                                        {t('go_back', 'На главную', '/error', translates)}
                                    </A>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Single>
    );
};

export default ErrorPage;
